"use strict";

const Misc = () => {
    const init = () => {
        $(function() {
            window.refreshUserSessions = function(){
                var $designPrice = $('.js-design-price');
                if ($designPrice.length > 0) {
                    var $sessions = $designPrice.find('.js-user-session');
                    var $form = $designPrice.find('.js-user-session-form');
                    $sessions.on('click', function(e){
                        if(!$(e.target).hasClass('btn') && $(e.target).parents('.btn').length <= 0 && !$(e.target).hasClass('share-icon') && $(e.target).parents('.share-icon').length <= 0){
                            $sessions.removeClass('active');
                            $(this).addClass('active');
                            $form.find('input[name="session"]').val($(this).data('id'));
                            $form.find('.ajax-submit').trigger('click');
                            $designPrice.addClass('summary-view');
                            $('html, body').animate({
                                scrollTop: $designPrice.offset().top
                            }, 100);
                        }
                    });
                }
            }
            window.refreshSelectedUserSession = function(){
                var $designPrice = $('.js-design-price');
                if ($designPrice.length > 0) {
                    var $sessions = $designPrice.find('.js-user-session');
                    var $backButton = $designPrice.find('.js-user-session-back');
                    $backButton.on('click', function(e){
                        $designPrice.removeClass('summary-view');
                        $sessions.removeClass('active');
                    });
                }
            }
            refreshUserSessions();
            refreshSelectedUserSession();
        });
    };

    return {
        init:init
    };
};

export default Misc;